/**
 * Pulse placeholder block. Use shape variants where the loading
 * surface is predictable (a list of rows, a card grid).
 */
export function Skeleton({ className = '' }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={`animate-pulse rounded-token-sm bg-surface-2 ${className}`}
    />
  );
}

/**
 * Convenience: a column of N rows mimicking a list. Used by
 * reception, station, coordinator, etc. in place of "Loading...".
 */
export function SkeletonList({
  rows = 5,
  height = 'h-14',
}: {
  rows?: number;
  height?: string;
}) {
  return (
    <div className="divide-y divide-divider/10">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="flex items-center gap-3 px-4 py-3">
          <Skeleton className={`w-full ${height}`} />
        </div>
      ))}
    </div>
  );
}

/**
 * Card-shaped skeleton. Used on dashboard tiles while user data loads.
 */
export function SkeletonCard({ className = '' }: { className?: string }) {
  return (
    <div
      className={`rounded-token-lg border border-line/10 bg-surface p-5 shadow-token-sm ${className}`}
    >
      <div className="flex items-start gap-3">
        <Skeleton className="h-10 w-10 flex-none" />
        <div className="min-w-0 flex-1 space-y-2">
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-4/5" />
        </div>
      </div>
    </div>
  );
}
